// components/NewsThemes.jsx - Composant sélection des thèmes (CORRECTION 2: sans contrôles d'affichage)
import React from 'react';
import { 
  Layers, 
  Star, 
  Loader2, 
  Target, 
  Clock 
} from 'lucide-react';

const NewsThemes = ({
  themes,
  selectedTheme,
  newsByTheme,
  isDiscovering,
  objectiveId,
  objectiveTheme,
  getNewsThemeFromObjective,
  onThemeSelect,
  onDiscoverTheme
}) => {
  // ================================
  // FONCTIONS UTILITAIRES
  // ================================

  const getTotalNewsCount = () => {
    return Object.values(newsByTheme).flat().length;
  };

  const getThemeNewsCount = (themeId) => {
    return newsByTheme[themeId]?.length || 0;
  };

  const isObjectiveTheme = (themeId) => {
    return objectiveId && themeId === getNewsThemeFromObjective(objectiveTheme);
  };

  // ================================
  // GESTIONNAIRES D'ÉVÉNEMENTS
  // ================================

  const handleDiscoverClick = (e, themeId) => {
    e.stopPropagation();
    onDiscoverTheme(themeId);
  };

  // ================================
  // RENDU DU COMPOSANT
  // ================================

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8 shadow-sm">

      
      {/* Statistiques en bas */}
      <div className="mt-6 flex items-center justify-center gap-6 text-sm text-gray-600 pt-4 border-t border-gray-200">
        <div className="flex items-center gap-2">
          <span className="font-medium text-blue-600">{getTotalNewsCount()}</span>
          <span>actualités au total</span>
        </div>
        
        {objectiveId && (
          <div className="flex items-center gap-1">
            <Target className="h-4 w-4 text-blue-600" />
            <span>Focus sur votre objectif</span>
          </div>
        )}
        
        <div className="flex items-center gap-1">
          <Clock className="h-4 w-4" />
          <span>3 derniers mois</span>
        </div>
      </div>
    </div>
  );
};

export default NewsThemes;